// Utils
import { elementMatchesElementFilter } from './elementFilterUtil';
import { getElementId, getModifiedBy } from '../../../../common/elements/utils/elementPropertyUtils';
import { getElementFilterIds, getElementFilterQuery } from '../elementFilterSelector';

import { ElementFilterData, ElementFilterDataMap, ElementFilterParams } from './elementFilterDataTypes';
import { ImMNElement } from '../../../../common/elements/elementModelTypes';

export default ({ elementFilter, currentBoardDeepChildren, comments }: ElementFilterParams): ElementFilterDataMap => {
    const hasFilter = getElementFilterQuery(elementFilter);

    if (!hasFilter) return {};

    const matchesIdQuery = (element: ImMNElement | undefined) => {
        const filterIds = getElementFilterIds(elementFilter);
        if (!filterIds) return false;

        const elementId = getElementId(element);
        return filterIds.includes(elementId);
    };

    return currentBoardDeepChildren
        .filter(elementMatchesElementFilter(elementFilter, comments))
        .map(
            (child): ElementFilterData => ({
                elementId: getElementId(child),
                pass: true,
                focus: matchesIdQuery(child),
                actorIds: [getModifiedBy(child)],
            }),
        )
        .toJS();
};
